import { lazy } from "react"

// ** Document title
const TemplateTitle = "%s - Vuexy React Admin Template"

// ** Default Route
const DefaultRoute = "/sports"
const MatchRoute = "/match"

// ** Merge Routes
const Routes = [
	{
		path: MatchRoute,
		component: lazy(() => import("../../views/Match")),
	},
	{
		path: "/login",
		component: lazy(() => import("../../views/Login")),
	},
	{
		path: "/beforeMatch",
		component: lazy(() => import("../../views/BeforeMatch")),
	},
	{
		path: DefaultRoute,
		component: lazy(() => import("../../views/ViewSports")),
	},
	{
		path: "/old-matches",
		component: lazy(() => import("../../views/ViewOldMatches")),
	},
	{
		path: "/old-match",
		component: lazy(() => import("../../views/PreviewOldMatch")),
	},
	{
		path: "/matches",
		component: lazy(() => import("../../views/ViewMatches")),
	},
	{
		path: "/error",
		component: lazy(() => import("../../views/Error")),
	},
]

export { DefaultRoute, MatchRoute, TemplateTitle, Routes }
